<template>
  <div>
    <slot></slot>
    <v-top v-if="isShow">

    </v-top>
    <v-body :params="params" :type="type" :types="types">
    </v-body>
  </div>
</template>
<script>
  import Top from './Top.vue';
  import Body from './Body.vue';
  export default{
    name:'result',
    props:['params','type','types'],
    data(){
      return {
        isShow: true
      }
    },
    components:{
      'v-top':Top,
      'v-body':Body
    },
    created() {
      // 新排行榜去掉筛选功能
      var q = this.$route.query.q;
      if (q) {
        q = q.replace(/\"/g, "");
        this.isShow = q.indexOf("top=4") < 0;
      }
    },
    mounted(){
    },
    methods:{

    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Result.vue?494b1388